import styles from '../TaskExecution.module.scss';
import { FormDefinitionElement, TASKFORM_DEFINITION_TYPES, TaskExecutionType } from '../../../api/models/tasks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface TaskParametersProps {
  selectedTask: TaskExecutionType;
  parameterDefinitions: FormDefinitionElement[];
}

const TaskParameters = (props: TaskParametersProps) => {
  const { selectedTask, parameterDefinitions } = props;

  function formatParameters() {
    return (
      <div className={styles.parametersGrid}>
        {parameterDefinitions.map((elem) => {
          const value = selectedTask.executingParameters[elem.id];
          return (
            <div className={styles.metaDataElement} key={`param-${elem.id}`}>
              <div className={styles.taskExecutionKey}>{elem.displayName}</div>
              {elem.type === TASKFORM_DEFINITION_TYPES.BOOLEAN ? (
                <div className={styles.taskExecutionVal}>
                  {value ? <FontAwesomeIcon icon="check" /> : <FontAwesomeIcon icon="xmark" />}
                </div>
              ) : (
                <div className={styles.taskExecutionVal}>{value || ''}</div>
              )}
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <>
      {Object.keys(selectedTask.executingParameters).length === 0 ? (
        <p>There are no parameters set for this task execution</p>
      ) : (
        <>{formatParameters()}</>
      )}
    </>
  );
};

export default TaskParameters;
